import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998a1 1 0 0 0-1.627-.78L6.315 9.286H4.001a1 1 0 0 0-1 1v4.288a1 1 0 0 0 1 1h2.372l5.085 3.27a1 1 0 0 0 1.541-.84V5.998Zm-5.706 5.067 3.705-2.98v8.085l-3.79-2.438a1 1 0 0 0-.542-.16H5.001v-2.287h1.666a1 1 0 0 0 .627-.22Zm10.128-3.096a1 1 0 0 1 1.4-.196 5.411 5.411 0 0 1 2.176 4.21v.037c-.032 1.664-.847 3.208-2.175 4.21a1 1 0 1 1-1.204-1.597A3.413 3.413 0 0 0 18.998 12a3.413 3.413 0 0 0-1.38-2.631 1 1 0 0 1-.196-1.4ZM14.74 9.71a1 1 0 0 1 1.395-.236c.248.177.47.39.656.632 1.093 1.403.772 3.388-.647 4.421a1 1 0 0 1-1.177-1.617c.534-.389.623-1.093.245-1.576l-.007-.01a1.07 1.07 0 0 0-.23-.22 1 1 0 0 1-.235-1.394Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerRoundLine);
export default Memo;
